import { fmtDayMonth } from './ratingFormat';
import { HexBadge } from './HexBadge';
import type { PersonalRating } from '../../api/types';
import { SheetClose } from '../SheetClose';

/**
 * Лестница уровней личного рейтинга + плитки пиков — bottom-sheet по
 * «Подробнее →» на карточке RA1 (итерация 2: отдельного экрана RB1 нет).
 */
export function LevelLadderSheet({
  rating,
  onClose,
}: {
  rating: PersonalRating;
  onClose: () => void;
}) {
  const value = rating.value ?? 1000;
  const current = rating.level;
  const next = rating.levels.find((l) => l.n === current + 1) ?? null;

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div className="sheet rating-ladder-sheet" onClick={(e) => e.stopPropagation()}>
        <SheetClose onClose={onClose} />
        <div className="rl-title">Уровни личного рейтинга</div>

        <div className="rl-list">
          {rating.levels.map((l) => {
            const passed = l.n < current;
            const isCurrent = l.n === current;
            return (
              <div key={l.n} className={`rl-row ${isCurrent ? 'rl-row--current' : passed ? 'rl-row--passed' : 'rl-row--future'}`}>
                <HexBadge level={l.n} size={20} />
                <div className="rl-info">
                  <div className="rl-name">
                    Уровень {l.n}
                    {l.title ? <span className="rl-name-title">{l.title}</span> : null}
                  </div>
                  {isCurrent && next ? (
                    <>
                      <div className="rl-bar">
                        <i
                          style={{
                            width: `${Math.min(100, Math.max(4, ((value - l.threshold) / (next.threshold - l.threshold)) * 100))}%`,
                          }}
                        />
                      </div>
                      <div className="rl-progress mono">
                        {value} ИЗ {next.threshold} · ОСТАЛОСЬ {Math.max(0, next.threshold - value)}
                      </div>
                    </>
                  ) : (
                    <div className="rl-threshold mono">{l.n === 1 ? `< ${rating.levels[1]?.threshold ?? 1000}` : `от ${l.threshold}`}</div>
                  )}
                </div>
                {passed ? (
                  <svg className="rl-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 12.5l5 5L20 7" />
                  </svg>
                ) : !isCurrent ? (
                  <svg className="rl-lock" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9}>
                    <rect x="5" y="11" width="14" height="9" rx="2" />
                    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
                  </svg>
                ) : null}
              </div>
            );
          })}
        </div>

        <div className="rl-peaks">
          <div className="rl-peak rl-peak--career">
            <div className="lbl">ПИК КАРЬЕРЫ</div>
            <div className="val mono">{rating.peak ? rating.peak.value : '—'}</div>
            {rating.peak && <div className="sub">{fmtDayMonth(rating.peak.date)}</div>}
          </div>
          <div className="rl-peak">
            <div className="lbl">ПИК СЕЗОНА</div>
            <div className="val mono">{rating.seasonPeak ? rating.seasonPeak.value : '—'}</div>
            {rating.seasonPeak && <div className="sub">Сезон {rating.seasonPeak.seasonId}</div>}
          </div>
        </div>

        <button className="btn rl-close" onClick={onClose}>
          Понятно
        </button>
      </div>
    </div>
  );
}
